import React from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import OptionListOption from "components/OptionListOption";
import { usePageBuilderContext } from "utils/context";
import Analytics, { SELECT_OPTION } from "utils/analytics";

const DEFAULT_CLASSES = {
  container: "ma0 pa0 list"
};

const COMPONENT = "OptionListPicker";

const OptionListPicker = ({
  name,
  value,
  multiselect,
  options,
  onClick,
  beforeClick,
  canUnset,
  customClasses,
  disabled,
  hideIcon
}) => {
  const isMultiselect = multiselect && Array.isArray(value);
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const pageBuilderCtx = usePageBuilderContext();
  const tracking = get(pageBuilderCtx, "tracking", {});
  const { touched, setFieldValue, setFieldTouched } = useFormikContext();
  const nodes = options.map((option, optionIx) => {
    const isFirst = !optionIx;
    const isLast = options.length - 1 === optionIx;
    const hasMultiple = options.length > 1;

    const isSelected = isMultiselect
      ? value.indexOf(option.uid) > -1
      : value === option.uid;

    const optionProps = {
      ...option,
      isLast,
      isFirst,
      hasMultiple,
      disabled: Boolean(disabled || option.disabled),
      hideIcon,
      onClick: () => {
        beforeClick && beforeClick();
        const nullUnset = Boolean(canUnset && !multiselect && isSelected);
        const setValue = nullUnset ? null : option.uid;
        setValue &&
          Analytics.track(SELECT_OPTION, {
            ...tracking,
            option: setValue,
            component: COMPONENT
          });

        const setFn = onClick || setFieldValue;

        const handleDefaultMultiselect = Boolean(
          isMultiselect && setValue && !onClick
        );

        if (handleDefaultMultiselect) {
          const updatedMultiValue = [...value];
          const matchIndex = updatedMultiValue.findIndex(
            (multiVal) => multiVal === setValue
          );
          let shouldUpdate = false;
          if (matchIndex >= 0) {
            if (canUnset) {
              shouldUpdate = true;
              updatedMultiValue.splice(matchIndex, 1);
            }
          } else {
            shouldUpdate = true;
            updatedMultiValue.push(setValue);
          }
          if (shouldUpdate) {
            setFn(name, updatedMultiValue);
            if (!get(touched, name)) {
              setFieldTouched(name, true);
            }
          }
        } else {
          setFn(name, setValue);
          if (!get(touched, name)) {
            setFieldTouched(name, true);
          }
        }
      }
    };
    if (classes.option) {
      optionProps.customClasses = classes.option;
    }

    optionProps.isSelected = isSelected;

    return (
      <OptionListOption key={`${options.uid}-${optionIx}`} {...optionProps} />
    );
  });

  return <ul className={classes.container}>{nodes}</ul>;
};

export default OptionListPicker;
